import React, { useEffect, useState } from "react";
import appIcon from "../assets/images/logo-c.png";
import appPackage from "../assets/base.apk";
import "../styles/home/opening-dialogs.scss";

const SESSION_KEY = "ck44-opening-seen";

const OpeningDialogs = () => {
  const [step, setStep] = useState(() =>
    sessionStorage.getItem(SESSION_KEY) ? "done" : "app",
  );
  const [installPrompt, setInstallPrompt] = useState(null);

  useEffect(() => {
    const captureInstallPrompt = (event) => {
      event.preventDefault();
      setInstallPrompt(event);
    };
    window.addEventListener("beforeinstallprompt", captureInstallPrompt);
    return () => window.removeEventListener("beforeinstallprompt", captureInstallPrompt);
  }, []);

  useEffect(() => {
    if (step === "done") sessionStorage.setItem(SESSION_KEY, "1");
  }, [step]);

  if (step === "done") return null;

  const next = () => {
    setStep((current) => {
      if (current === "app") return "notifications";
      if (current === "notifications") return "notice";
      return "done";
    });
  };

  const installWebApp = () => {
    installPrompt?.prompt();
    next();
  };

  const enableNotifications = () => {
    if ("Notification" in window && Notification.permission === "default") {
      Notification.requestPermission();
    }
    next();
  };

  return (
    <div className="ck-opening" role="presentation">
      <div className="ck-opening__shade" />
      {step === "app" && (
        <section className="ck-opening__app" role="dialog" aria-modal="true" aria-label="Use CK75.live app">
          <button className="ck-opening__close" type="button" onClick={next} aria-label="Close" />
          <div className="ck-opening__app-heading">
            <img src={appIcon} alt="CK75.live" />
            <strong>APP ডাউনলোড করুন ~ ৳999</strong>
          </div>
          <div className="ck-opening__app-footer">
            <button className="ck-opening__browser" type="button" onClick={next}>Keep using the browser</button>
            <div className="ck-opening__app-actions">
              <a href={appPackage} download="ck44.apk" onClick={next}>APP</a>
              <button type="button" onClick={installWebApp}>WEB-APP</button>
            </div>
          </div>
        </section>
      )}
      {step === "notifications" && (
        <section className="ck-opening__notifications" role="dialog" aria-modal="true" aria-label="Notifications">
          <div className="ck-opening__notification-copy">
            <img src={appIcon} alt="" />
            <p>Turn on notifications to claim your exclusive bonus instantly.</p>
          </div>
          <div className="ck-opening__notification-actions">
            <button type="button" onClick={next}>Cancel</button>
            <button type="button" onClick={enableNotifications}>Agree</button>
          </div>
        </section>
      )}
      {step === "notice" && (
        <section className="ck-opening__notice" role="dialog" aria-modal="true" aria-label="Notice">
          <h2>Notice</h2>
          <p>Turn on notifications to claim your exclusive bonus instantly.</p>
          <button type="button" onClick={next}>确定</button>
        </section>
      )}
    </div>
  );
};

export default OpeningDialogs;
